define('widgets/inputs/password/viewmodel',['knockout', 'widgets/inputs/AbstractInputWidget'], function (ko, AbstractInputWidget) {

    /**
     * Usage:
     *
     *      <div data-bind="inputs.password: settings"></div>
     *
     * Settings:
     *      {core/FormFields.passwordField} field
     *      {Observable String} label
     *      {Boolean} autoFocus (Default: false)
     */
    function PasswordInputWidget() {

        AbstractInputWidget.call(this);

        this.type = ko.pureComputed(function() {
            return (this.field.isRevealed() ? 'text' : 'password');
        }.bind(this));

    }

    PasswordInputWidget.prototype = Object.create(AbstractInputWidget.prototype);

    /**
     * Toggle the revealed state while maintaining the focus of the field
     */
    PasswordInputWidget.prototype.togglesRevealed = function() {

        return function() {
            this.field.isRevealed( !this.field.isRevealed() );
            this.field.isFocused(true);
        }.bind(this);

    };

    return PasswordInputWidget;

});

